/**
 * Function that maps callStats data into a new object with as many properties as the tabs you want to show
 * each one with counters, donut and legend data to display.
 *
 * @param {Object} callStats - Object. Contains the call stats from BE.
 * @param {Object} intl - Object. Contains internationalization messages.
 * @param {Object} theme - Object. Contains the DbeTheme properties.
 *
 * @returns {Object} Formatted call stats for StatsBox component.
 */

export default (callStats, intl, allOutcomes) => {
  const {
    contactCount,
    calledContactCount,
    userContactCallsCount,
    outcomeCounters,
  } = callStats?.callCount || {};
  const mapDonutCounters = (sourceArray) =>
    sourceArray.map(({ name, count, id }) => ({
      id: intl.messages[name?.toUpperCase()] || name,
      value: count,
      color: allOutcomes.find((x) => x?.id === id)?.color,
    }));

  return {
    counters: {
      CONTACTS: contactCount,
      CALLED: [calledContactCount, contactCount],
      MY_CALLS: userContactCallsCount,
    },
    donut: mapDonutCounters(outcomeCounters),
    legend: {
      data: mapDonutCounters(outcomeCounters)?.map(
        ({ id, value }) => `${id}: ${value}`
      ),
      colors: mapDonutCounters(outcomeCounters)?.map(({ color }) => color),
    },
  };
};
